import { ImageVariant } from '../types/catalog';

export const isIE = () => {
    const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    const msie = ua.indexOf('MSIE '); // IE 10 or older
    const trident = ua.indexOf('Trident/'); //IE 11

    return msie > 0 || trident > 0;
};
const transparentExt = isIE() ? '.png' : '.webp';
const ext = isIE() ? '.jpg' : '.webp';
const isPng = (url: string | null | undefined) => {
    return !!(url && url.endsWith('.png'));
};
export const selectImage = (
    variants: ImageVariant[],
    maxWidth: number,
    minWidth: number,
    def?: string | null
) => {
    let bestVariant = undefined;
    const targetExt = isPng(def) ? transparentExt : ext;
    for (const variant of variants) {
        if (variant.ext === targetExt && variant.width <= maxWidth && variant.width >= minWidth) {
            if (!bestVariant || bestVariant.width < variant.width) {
                bestVariant = variant;
            }
        }
    }
    return bestVariant?.url || def || undefined;
};
export function debounce(func: Function, timeout = 300) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            // @ts-ignore
            func.apply(this, args);
        }, timeout);
    };
}
